import { api } from './client'

export function fetchExchangeSettings() {
  return api.get('/exchange/settings').then((r) => r.data)
}

export function updateExchangeSettings(body) {
  return api.put('/exchange/settings', body).then((r) => r.data)
}
